import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatDateForInput, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_INDIVIDUALS,
	STR_GROUPS,
	STR_CREATE_NEW_CONTACT,
	STR_INVALID_NAME,
	STR_INVALID_PHONE,
	STR_INVALID_WHATSAPP_NUMBER,
	STR_SUCCESS,
	STR_NAME,
	STR_PHONE_NUMBER,
	STR_WHATSAPP_NUMBER,
	STR_OPTIONAL,
	STR_SUBMIT,
	STR_CREATE_NEW_CONTACT_GROUP,
	STR_DESCRIPTON,
	STR_INVALID_TITLE,
	STR_CREATE_NEW,
	STR_MESSAGE_TITLE,
	STR_MESSAGE_BODY,
	STR_MESSAGE_TO_BE_SENT,
	STR_MESSAGE_TYPE,
	STR__NORMAL_SMS,
	STR_WHATSAPP_MESSAGE,
	STR_SENDER_ID,
	STR_SEND,
	STR_IMAGE,
	STR_RECEPIENTS,
	STR_INVALID_RECEPIENTS,
	STR_INVALID_MESSAGE,
	STR_SCHEDULE_MESSAGE,
	STR_YES,
	STR_NO,
	STR_SCHEDULED_AT,
	STR_LEADS,
	STR_CLIENTS,
	STR_SMS_COUNT,
	STR_CHARACTERS_COUNT,
	STR_ONLY_ALPHANUMERIC_CHARACTES,
	STR_CONNECT_WHATSAPP
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdInfoOutline, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdWarning } from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import WhatsAppSetupStatus from "../ones/WhatsAppSetupStatus";

export default function View({ appType, accountId }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState("");
	const [body, setBody] = useState("");
	const [messageType, setMessageType] = useState("normalSms");
	const [contactGroupId, setContactGroupId] = useState("");
	const [senderId, setSenderId] = useState("WERENIUM");
	const [isScheduled, setIsScheduled] = useState('no');
	const [scheduledAtDate, setScheduleAtDate] = useState('');
	const [image, setImage] = useState(null);

	const [charsCount, setCharsCount] = useState(0);
	const [smsCount, setSmsCount] = useState(0);
	

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getAllContactGroups(),
			appContext.getCurrentUserData(),
		])
		setReady(true);
	}

	function getImage(e) {
		// Ensure the event has a file input with a file selected
		if (e.target && e.target.files && e.target.files[0]) {
			const file = e.target.files[0];

			// Use FileReader to read the file and generate a URL
			const reader = new FileReader();

			// On load, set the result (URL) to an image src or handle it as needed
			reader.onload = function (event) {
				const fileURL = event.target.result;
				setImage(fileURL); // Replace with your image handling logic
			};

			// Read the file as a Data URL
			reader.readAsDataURL(file);
		} else {
			//..
		}
	}

	async function createMessage() {
		let _image = null;

		try {
			_image = document.getElementById('_image').files[0];
		} catch (error) {
			//..
		}
		
		if(title && title.trim().length > 0) {
			
			if(body && body.trim().length > 0) {
				if(contactGroupId) {
					if(
						(messageType === 'whatsApp' && (appContext.currentUserData.whatsAppBotStatus === 'ready' || appContext.currentUserData.whatsAppBotStatus === 'CONNECTED')) ||
						(messageType === 'normalSms')
					){
						///...
						setLoading(true);
						await callApi(
							"create-message",
							{
								title,
								body,
								messageType,
								contactGroupId,
								senderId,
								messageMedia: _image ? _image : "",
								isScheduled,
								scheduledAtDate,
								appType,
								accountId,
							}
						).then((response) => {
							if(response.status === 1) {
								appContext.tellMessage(STR_SUCCESS[appContext.language]);
								appContext.getAllMessages();
								appContext.navBack();
							} else {
								appContext.tellError(response.msg);
							}
						})
						setLoading(false);
						///...
					} else {
						appContext.tellError(STR_CONNECT_WHATSAPP[appContext.language]);
					}
					
				} else {
					appContext.tellError(STR_INVALID_RECEPIENTS[appContext.language]);
				}
			} else {
				appContext.tellError(STR_INVALID_MESSAGE[appContext.language]);
			}
		} else {
			appContext.tellError(STR_INVALID_TITLE[appContext.language]);
		}
	}

	useEffect(() => {
    let _charsCount = body.length || 0;
    let _smsCount = 0;

    if (_charsCount > 0) {
        const smsLength = Number(appContext.systemParams.normalSmsLength) || 160;
        
        // If chars count is greater than 0, calculate the number of SMS messages
        // If the chars count is less than or equal to 160, it's 1 SMS.
        _smsCount = Math.ceil(_charsCount / smsLength);
    }

    setCharsCount(_charsCount);
    setSmsCount(_smsCount);
	}, [body]);


	useEffect(() => {
		init();
	}, [])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
	}, [ loading ])

	if (ready) {
		return (
			<div
				className="container"
			>
			
				<div className="row">

					<div className="col-md-12">
						<h6
							className="mSectionTitle"
						>
							{STR_CREATE_NEW[appContext.language]}
						</h6>
					</div>

					<div className="col-md-12">
						<div className="mb-3 mt-3">
							<label className="form-label">{STR_MESSAGE_TITLE[appContext.language]}</label>
							<input
								className="form-control"
								value={title}
								onChange={(e) => setTitle(e.target.value)}
							/>
						</div>

						<div className="mb-3 mt-3">
							<label className="form-label">{STR_SCHEDULE_MESSAGE[appContext.language]}</label>
							<select
								className="form-control"
								value={isScheduled}
								onChange={(e) => setIsScheduled(e.target.value)}
							>
								<option value="yes">{STR_YES[appContext.language]}</option>
								<option value="no">{STR_NO[appContext.language]}</option>
							</select>
						</div>

						{
							(isScheduled === 'yes') ?
							<div className="mb-3 mt-3">
								<label className="form-label">{STR_SCHEDULED_AT[appContext.language]}</label>
								<input
									className="form-control"
									value={scheduledAtDate}
									type="datetime-local"
									onChange={(e) => setScheduleAtDate(e.target.value)}
								/>
							</div>
							:""
						}

						<div className="mb-3 mt-3">
							<label className="form-label">{STR_RECEPIENTS[appContext.language]}</label>
							<select
								className="form-control"
								value={contactGroupId}
								onChange={(e) => setContactGroupId(e.target.value)}
							>
								<option value=""></option>
								{
									(!appType && !accountId) ?
									(appContext.allContactGroups && appContext.allContactGroups.length > 0) ?
									appContext.allContactGroups.map((item, i) => {
										return (
											<option value={item.id} key={i}>{item.name}</option>
										)
									})
									:""
									:""
								}

								{
									(appType === 'mauzocrm' && accountId) ?
									<>
										<option value="leads" >{STR_LEADS[appContext.language]}</option>
										<option value="clients" >{STR_CLIENTS[appContext.language]}</option>
									</>
									:""
								}
							</select>
						</div>

						<div className="mb-3 mt-3">
							<label className="form-label">{STR_MESSAGE_TYPE[appContext.language]}</label>
							{
								(messageType === 'whatsApp') ?
								<WhatsAppSetupStatus/>
								:""
							}
							<select
								className="form-control"
								value={messageType}
								onChange={(e) => setMessageType(e.target.value)}
							>
								<option value="normalSms">{STR__NORMAL_SMS[appContext.language]}</option>
								<option value="whatsApp">{STR_WHATSAPP_MESSAGE[appContext.language]}</option>
							</select>
						</div>

						{
							(messageType === 'normalSms') ?
							<div className="mb-3 mt-3">
								<label className="form-label">{STR_SENDER_ID[appContext.language]}</label>
								<select
									className="form-control"
									value={senderId}
									onChange={(e) => setSenderId(e.target.value)}
								>
									<option value="WERENIUM">WERENIUM</option>

									{
										JSON.parse(appContext.currentUserData.senderId).map((item, i) => {
											return (
												<option key={i} value={item}>{item}</option>
											)
										})
									}
								</select>
							</div>
							:""
						}

						<div className="mb-3 mt-3">
							<label className="form-label d-block">{STR_MESSAGE_BODY[appContext.language]}</label>

							{
								(messageType === 'normalSms') ?
								<div className="row">
									<div className="col-6">
										<div
											style={{
												border: "1px solid var(--primaryColor)",
												padding: "10px",
												borderRadius: "10px"
											}}
										>
											<h6
												style={{
													fontSize: "24px",
												}}
											>
												{smsCount}	
											</h6>
											<label className="form-label" style={{ fontSize: "12px" }}>{STR_SMS_COUNT[appContext.language]}</label>
										</div>
									</div>

									<div className="col-6">
										<div
											style={{
												border: "1px solid var(--primaryColor)",
												padding: "10px",
												borderRadius: "10px"
											}}
										>
											<h6
												style={{
													fontSize: "24px",
												}}
											>
												{charsCount}	
											</h6>
											<label className="form-label" style={{ fontSize: "12px" }}>{STR_CHARACTERS_COUNT[appContext.language]}</label>
										</div>
									</div>

								</div>
								:""
							}

							<div className="form-text">
								{STR_MESSAGE_TO_BE_SENT[appContext.language]}
							</div>
							<textarea
								className="form-control"
								value={body}
								onChange={(e) => {
									if(messageType === 'normalSms') {
										const newValue = e.target.value.replace(/[^a-zA-Z0-9 ,.-?'"']/g, ''); 
            				setBody(newValue);
									} else {
										setBody(e.target.value)
									}
								}}
							/>
							<div className="text-start">
								{
									(messageType === 'normalSms') ?
									<h6
										className="font-semi-bold text-danger"
										style={{
											fontSize: "14px"
										}}
									>
										<MdWarning/> {STR_ONLY_ALPHANUMERIC_CHARACTES[appContext.language]}
									</h6>
									:""
								}
							</div>
							
						</div>

						{
							(messageType === 'whatsApp') ?
							<div className="mb-3 mt-3">
								<label className="form-label">{STR_IMAGE[appContext.language]}</label>
								<input
									className="form-control"
									type="file"
									accept="image/png, image/jpeg, image/jpg"
									id="_image"
									onChange={(e) => getImage(e)}
								/>

								{
									(image) ?
										<div
											style={{
												width: "100%",
												height: "200px",
												overflow: "hidden",
											}}
											className="bg-surface"
										>
											<img
												style={{
													objectFit: "contain",
													width: "100%",
													height: "100%",
												}}
												src={image}
											/>
										</div>
										: ""
								}
							
								<div className="form-text">
									{STR_OPTIONAL[appContext.language]}
								</div>
							</div>
							:""
						}

						<div className="mb-3 mt-3 text-end">
							<button
								className="btn btn-rounded bg-secondary btn-padded"
								onClick={() => {
									appContext.activateDialog({
										message: STR_SEND[appContext.language]+'?',
										onConfirm: createMessage,
									})
								}}
							>
								{STR_SEND[appContext.language]}
							</button>
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}